export default {
	requiredMessage: '請選擇一個值。'
};
